module.exports = __webpack_public_path__ + "static/media/new_categories.9d4c9a10.svg";